export default {
    banners: {
        tarot: {
            text: 'O destino resolveu te dar uma ajudinha e te <b>presenteou</b> com uma <b>consulta ao Tarot!</b>',
            imgAlt: 'Mão segurando carta de tarot'
        }
    }
};